import { Input } from "@/components/ui/input";

interface SliderConfigurationProps {
  sliderConfig: { min: number; max: number } | undefined;
  onSliderConfigChange: (key: "min" | "max", value: string) => void;
  disabled?: boolean;
}

const SliderConfiguration = ({
  sliderConfig,
  onSliderConfigChange,
  disabled = false,
}: SliderConfigurationProps) => {
  if (!sliderConfig) {
    return null;
  }

  return (
    <div className="space-y-2 rounded-lg border border-border/70 bg-muted/20 p-3">
      <div className="grid grid-cols-2 gap-2">
        <div className="space-y-1.5">
          <label htmlFor="min" className="text-xs font-medium text-muted-foreground">
            Minimum
          </label>
          <Input
            id="min"
            type="number"
            className="h-8"
            value={sliderConfig.min ?? 0}
            onChange={e => onSliderConfigChange("min", e.target.value)}
            disabled={disabled}
          />
        </div>
        <div className="space-y-1.5">
          <label htmlFor="max" className="text-xs font-medium text-muted-foreground">
            Maximum
          </label>
          <Input
            id="max"
            type="number"
            className="h-8"
            value={sliderConfig.max || ""}
            onChange={e => onSliderConfigChange("max", e.target.value)}
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  );
};

export default SliderConfiguration;
